<template>
  <div class="aside-attr" @click.stop>
    <div class="aside-attr-title">
      <span>模块组</span>
      <a style="margin-right: 20px" class="c-f-right" @click="onCopyModule">复制</a>
      <a style="margin-right: 20px" class="c-f-right" @click="onRemoveModule">删除</a>
    </div>
    <div class="aside-attr-body module-panel">
      <section class="module-group-operation" :style="{border: moduleGroupList.length === 0 ? '0px': null}"
               v-show="currentModule.data.children && currentModule.data.edit === module_group_edit.one">
        <p><span class="md-title">修改模块组数量</span>
          <el-input-number class="module-num" v-model="modelModuleNum" readonly controls-position="right"
                           @change="onModuleNumChange" :min="1" :max="+currentModule.data.maxCount"></el-input-number>
        </p>
        <!--<el-button @click="onAddModuleGroupItem">添加</el-button>-->
        <!--<el-button @click="onDelModuleGroupItem">删除</el-button>-->
        <div class="module-list">
          <template v-for="(item, index) in moduleList">
            <div class="ml-item" :key="item.key" v-if="moduleGroupItemVisible(item)" :alt="item.name">
              <tpl-editor-area class="module-list-item"
                               :disabled="true"
                               :value="item"
                               :module-cover="true"
                               :scale="currentModule.scale"
                               :edit="false"
                               @onOperationModuleGroup="onOperationModuleGroup"></tpl-editor-area>
              <p>
                <span class="icon" :class="itemClass(item, 'up')" @click="upAndDown('up', item)"><i
                    class="el-icon-top"></i>上移</span>
                <span class="icon" :class="itemClass(item, 'down')" @click="upAndDown('down', item)"><i
                    class="el-icon-bottom"></i>下移</span>
                <span class="icon" @click="onCopyGroupItem(item, index)"><i class="el-icon-document-copy"></i>复制</span>
                <span class="icon" :class="{'disabled': oneModule}" @click="onDelCurrentModuleItem(item, index)"><i
                    class="el-icon-delete"></i>删除</span></p>
            </div>
          </template>
        </div>
      </section>
      <section class="module-group-box" v-if="moduleGroupList.length > 0">
        <p class="md-title">更换方案</p>
        <div class="fa-list" v-loading="loading"
             element-loading-text="正在加载数据..."
             element-loading-spinner="el-icon-loading">
          <template v-for="(item,index) in moduleGroupList">
            <div class="fa-list-item" :class="{'active': selectedModuleGroupItemIndex === index}"
                 @click="replaceModuleGroup(item, index)" :key="index">
              <el-tooltip content="编辑" placement="top" v-if="$store.getters['app/isAdmin']">
                <span class="fa-edit" @click.stop="onEditModule(item)"><i class="myico-edit"></i></span>
              </el-tooltip>
              <div class="m-cover">
                <tpl-editor-area :disabled="true" v-model="item.json" :scale="item.scale"
                                 :edit="false"></tpl-editor-area>
              </div>
              <p class="c-center fa-name" :title="item.name">{{item.name}}</p>
            </div>
          </template>
        </div>
      </section>
      <div v-if="noResult" class="noResult c-center" style="margin-top: 40px">
        <img src="img/noResult.png">
        <p class="c-gray">无模块组数据</p>
      </div>
    </div>
  </div>
</template>
<script>
    import tplEditorArea from '../editor/tpl-editor-area';
    import util from '@/util.js'
    import TUtil from '../TUtil'
    import {module_group_edit, template_type_ppt} from '@/const.js';

    export default {
        components: {tplEditorArea},
        props: {
            currentTemplate: Object,
            currentModule: {
                type: Object, default() {
                    return {data: {}, scale: 1}
                }
            },
            moduleGroupList: Array,
            loading: Boolean
        },
        data() {
            return {
                module_group_edit: module_group_edit,
                selectedModuleGroupItemIndex: null,
                modelModuleNum: 0,
                moduleChangeKey: 0,
                moduleList: [],
                multiDialogVisible: false,
                moduleItem: null
            }
        },
        computed: {
            oneModule() {
                return this.moduleList.filter((item) => {
                    return this.moduleGroupItemVisible(item)
                }).length === 1;
            },
            noResult() {
                let notShowModule = !(this.currentModule.data.children && this.currentModule.data.edit === module_group_edit.one);
                let noModuleList = this.moduleGroupList.length === 0;
                return notShowModule && noModuleList;
            }
        },
        watch: {
            currentModule: {
                handler(json) {
                    let newArr = json.data.children || [];
                    this.moduleList = newArr;
                    this.modelModuleNum = this.moduleList.filter((item) => {
                        return this.moduleGroupItemVisible(item);
                    }).length;
                },
                deep: true,
            }
        },
        created() {
        },
        methods: {
            moduleGroupItemVisible(item){
                return item.children && !item.noGroupItem && !item.isBgImg;
            },
            itemClass(item, type) {
                let set = new Set();
                if (['up', 'down', 'copy'].indexOf(type) > -1 && this.oneModule) {
                    set.add('disabled');
                }
                let dataList = this.moduleList.filter((obj) => {
                    return obj.children;
                });
                let isFirstItem = dataList.findIndex((obj) => {
                    return obj === item;
                }) === 0;
                if (isFirstItem && type === 'up') {
                    set.add('disabled');
                }
                let isLastItem = dataList.findIndex((obj) => {
                    return obj === item;
                }) === dataList.length - 1;
                if (isLastItem && type === 'down') {
                    set.add('disabled');
                }
                return [...set].join(' ');
            },
            onModuleNumChange(currentValue, oldValue) {
                let isAdd = currentValue > oldValue;
                let selectedModuleItem = this.$store.state.templateGroup.selectedItemForModuleGroup;
                this.changeModuleItem(isAdd, selectedModuleItem.item);
            },
            replaceModuleGroup(item, index) {
                this.selectedModuleGroupItemIndex = index;
                this.$emit('onReplaceModuleGroup', item)
            },
            onOperationModuleGroup(type) {
                let func = this.operationMapping()[type];
                func();
            },
            operationMapping() {
                return {
                    'up': () => {
                        this.upAndDown('up')
                    },
                    'down': () => {
                        this.upAndDown('down')
                    },
                    'copy': this.onCopyGroupItem,
                    'del': this.onDelCurrentModuleItem,
                }
            },
            getSameItem(item, children) {
                return children.filter((obj) => {
                    return obj.id === item.id;
                })[0];
            },
            upAndDown(type, item) {
                if (this.oneModule) {
                    return;
                }
                this.moduleChangeKey += 1;
                let parent = this.currentModule.data;
                let children = parent.children;
                let index = children.findIndex((obj) => {
                    return obj.id == item.id;
                });
                let isUp = type === 'up';
                let nextIndex = isUp ? index - 1 : index + 1;
                if (nextIndex > -1 && nextIndex < children.length) {
                    this.$emit('addCache');
                    let originItem = children[index];
                    let targetItem = children[nextIndex];
                    // 互换元素位置
                    children[index] = targetItem;
                    children[nextIndex] = originItem;
                    // 修改元素top值
                    let distance = +originItem.top - (+targetItem.top);
                    let minus = (+originItem.height) - (+targetItem.height);
                    if (isUp) {  //两元素高度不一样，互换位置时，会有元素被遮挡
                        this.updateTopForItem(originItem, -distance);
                        this.$nextTick(() => {
                            this.updateTopForItem(targetItem, distance + minus);
                        })
                    } else {
                        this.updateTopForItem(originItem, -distance - minus);
                        this.$nextTick(() => {
                            this.updateTopForItem(targetItem, distance);
                        })
                    }
                }
            },
            updateTopForItem(item, top) {
                item.top = +item.top + top;
                item.bottom = +item.bottom + top;
                if (item.children) {
                    item.children.forEach((child) => {
                        this.updateTopForItem(child, top);
                    });
                }
            },
            onDelLastModuleItem() {
                let selectedModuleItem = this.$store.state.templateGroup.selectedItemForModuleGroup;
                // this.$emit('onModuleNumChange', false, null , selectedModuleItem.item);
                this.changeModuleItem(false, null, selectedModuleItem.item);
                this.$store.commit('templateGroup/set_module_group_selected', {item: null, parent: null});
            },
            onDelCurrentModuleItem(item, index) {
                if (this.oneModule) {
                    return;
                }
                this.$emit('addCache');
                let parent = this.currentModule.data;
                let children = parent.children;
                let currentModule = this.currentModule.data;
                this.delGroupItem(currentModule, children, index);
                this.$store.commit('templateGroup/set_module_group_selected', {item: null, parent: null});
                this.$emit('autoSave');
            },
            changeModuleItem(isAdd, copyFromItem, delFromItem) {
                if (isAdd) {
                    this.onAddModuleGroupItem(copyFromItem);
                } else {
                    this.onDelModuleGroupItem(delFromItem);
                }
            },
            getLastItemIndex(dataList) { //查找最后一个有子元素的模块组，
                let newList = [].concat(dataList);
                newList.reverse();
                let idx = newList.findIndex((item) => {
                    return this.moduleGroupItemVisible(item);
                });
                return dataList.findIndex((item) => {
                    return item === newList[idx];
                });
            },
            onAddModuleGroupItem(selectedItem) {
                let item = this.currentModule.data;
                let dataList = item.children;
                let index = this.getLastItemIndex(dataList); // 复制最后一个元素
                this.$emit('addCache');
                let insertIndex = index; //插入到最后一个元素后面
                this.copyGroupItem(item, dataList, index, insertIndex, selectedItem);
                this.$emit('autoSave')
            },
            onCopyGroupItem(item, index) {
                if (this.t) {
                    return;
                }
                this.t = setTimeout(() => {
                    let parent = this.currentModule.data;
                    let dataList = parent.children;
                    let maxCount = +parent.maxCount;
                    let length = dataList.filter((item) => {
                        return item.children;
                    }).length;
                    if (maxCount > 0 && length >= maxCount) {
                        this.$message.error(`模板组数最多为${maxCount}个`);
                        this.t = null;
                        return;
                    }
                    this.$emit('addCache');
                    this.copyGroupItem(parent, dataList, index, index, item);
                    this.$emit('autoSave');
                    this.t = null;
                });
            },
            onDelModuleGroupItem(delFromItem) {
                if (this.t) {
                    return;
                }
                this.t = setTimeout(() => {
                    let item = this.currentModule.data;
                    let dataList = item.children;
                    let index = null;
                    if (delFromItem) {
                        index = dataList.findIndex((item) => {
                            return item.children && item === delFromItem;
                        })
                    } else {
                        index = this.getLastItemIndex(dataList); //删除最后一个元素
                    }
                    if (index !== -1) {
                        this.$emit('addCache');
                        this.delGroupItem(item, dataList, index);
                        this.$emit('autoSave')
                    }
                    this.t = null;
                }, 100)
            },
            getItemSpaceBetween(parent, dataList) { //获取两dom对象之间的间距
                let spaceBetween = parent.spaceBetween || 0;
                if (spaceBetween) {
                    return spaceBetween;
                }
                let newDataList = dataList.filter((item) => {
                    return this.moduleGroupItemVisible(item);
                });
                if (newDataList.length > 1) {
                    let bottom0 = +newDataList[0].bottom;
                    let bottom1 = +newDataList[1].bottom;
                    let top0 = +newDataList[0].top;
                    let top1 = +newDataList[1].top;
                    if (top0 > bottom1) {
                        spaceBetween = top0 - bottom1;
                    } else if (top1 > bottom0) {
                        spaceBetween = top1 - bottom0;
                    }
                }
                parent.spaceBetween = spaceBetween;
                return spaceBetween;
            },
            delGroupItem(currentModule, dataList, index) {
                let length = dataList.filter((item) => {
                    return item.children;
                }).length;
                if (length === 1) {
                    this.$message.error('至少保留一项数据');
                    return;
                }
                let item = dataList[index];
                let spaceBetween = this.getItemSpaceBetween(currentModule, dataList) + (+item.height);
                currentModule.height = +currentModule.height - spaceBetween; // 减少父元素高度
                currentModule.bottom = +currentModule.bottom - spaceBetween;
                dataList.splice(index, 1); // 删除元素
                this.delTopForOtherLower(+item.bottom, spaceBetween);
            },
            copyGroupItem(parent, dataList, index, insertIndex, cloneItem) {
                let tplJson = this.currentTemplate.json;
                let newItem = TUtil.copyItem(dataList, index, cloneItem);
                let spaceBetween = this.getItemSpaceBetween(parent, dataList);
                let afterItemBottom = +(dataList[insertIndex].bottom);
                let addHeight = spaceBetween + (+newItem.height);
                parent.height = +parent.height + addHeight; // 增加父元素高度
                parent.bottom = +parent.bottom + addHeight;
                tplJson.height = +tplJson.height + addHeight;
                newItem.name += ' 副本';
                newItem.originName = newItem.name;
                newItem.copy = true;
                this.$nextTick(() => {
                    tplJson.children.forEach((item) => {
                        this.moveLowerItemByTop(afterItemBottom, addHeight, item);
                    });
                    this.moveLowerItemInModule(afterItemBottom, addHeight, dataList);
                    dataList.splice(insertIndex + 1, 0, newItem); // 插入新元素
                    this.moveItem(addHeight, newItem);
                })
            },
            moveLowerItemInModule(top, height, children){
                children && children.forEach((item) => {
                    if(item.top > top){
                        item.top = (+item.top) + height;
                        item.bottom = item.top + (+item.height);
                        this.moveLowerItemInModule(top, height, item.children);
                    }
                })
            },
            addTopForOtherLower(newItem, targetBottom, addHeight) {
                let moduleItem = this.currentModule.data;
                let json = this.currentTemplate.json, moduleTop = +moduleItem.top, moduleBottom = +moduleItem.bottom;
                let isPPT = template_type_ppt === this.currentTemplate.type;
                if (!isPPT) { // ppt模板不支持模板高宽修改
                    json.height = +json.height + addHeight;
                }
                setTimeout(() => {
                    this.deepChildren(moduleTop, moduleBottom, newItem, json.children, targetBottom, addHeight);
                })
            },
            delTopForOtherLower(targetBottom, delHeight) {
                let moduleItem = this.currentModule.data;
                let json = this.currentTemplate.json, moduleTop = +moduleItem.top, moduleBottom = +moduleItem.bottom;
                let isPPT = template_type_ppt === this.currentTemplate.type;
                if (!isPPT) { // ppt模板不支持模板高宽修改
                    json.height = +json.height - delHeight;
                }
                setTimeout(() => {
                    this.deepChildren(moduleTop, moduleBottom, null, json.children, targetBottom, -delHeight);
                });
            },
            deepChildren(moduleTop, moduleBottom, excludeItem, children, targetBottom, addHeight) {
                children && children.forEach((item) => {
                    if (item.fixed) {
                        return;
                    }
                    if (item.top > 0 && +item.top < moduleTop) { // 模块组以上元素不做移动
                        return;
                    }
                    // 并行模块组，不做联动
                    if (item.isModuleGroup && item.top < moduleBottom && item !== this.currentModule.data) {
                        return;
                    }
                    if (+item.top >= moduleTop) { // 比较模块组及以下图层
                        if (item !== excludeItem && +item.top >= targetBottom) { //并且比当前元素低的图层
                            item.top = +item.top + addHeight;
                            item.bottom = +item.bottom + addHeight;
                            if (item.children) {
                                this.deepChildren(moduleTop, moduleBottom, excludeItem, item.children, targetBottom, addHeight)
                            }
                        } else if (item.isModuleGroup) { //模块组内图层
                            if (item.children) {
                                this.deepChildren(moduleTop, moduleBottom, excludeItem, item.children, targetBottom, addHeight)
                            }
                        }
                    }
                    if (+item.top === 0 && item.children) { // 根元素
                        this.deepChildren(moduleTop, moduleBottom, excludeItem, item.children, targetBottom, addHeight)
                    }
                });
            },
            onEditModule(item) {
                this.$store.commit('templateGroup/set_global_module', item);
                this.$store.commit('templateGroup/toggle_global_modal_dialog', true);
            },
            onRemoveModule() {
                this.$confirm('确定删除模块组么?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                   this.removeModule();
                }).catch(() => {
                });
            },
            removeLastModule(){ //最后一个模块只清空内容，不删除模块所占空间
                this.currentModule.data.children = [];
                this.$emit('onRemoveModule');
            },
            removeModule(){
                this.$emit('addCache');
                let item = this.currentModule.data,
                    parent = this.currentTemplate.json,
                    dataList = parent.children;
                let spaceBetween = item.blankSpace;
                let top = item.bottom;
                let minusHeight = -(spaceBetween + (+item.height));
                let moduleList = dataList.filter((item) => {
                    return item.isModuleGroup;
                });
                if(moduleList.length === 1){
                   this.removeLastModule();
                }else{
                    parent.height = +parent.height + minusHeight; // 减少父元素高度
                    parent.children.forEach((m) => {
                        this.moveLowerItemByTop(+item.bottom, minusHeight, m);
                    })
                    parent.children = dataList.filter((m) => {
                        return m !== item;
                    });
                    moduleList = parent.children.filter((item) => {
                        return item.isModuleGroup;
                    });
                    this.$emit('setCurrentModule',  moduleList[moduleList.length - 1]);
                }
            },
            onCopyModule(){
                this.$emit('addCache');
                let item = this.currentModule.data,
                    parent = this.currentTemplate.json,
                    dataList = parent.children;
                let insertIndex = dataList.findIndex((obj) => {
                    return obj ===  item;
                });
                let newItem = TUtil.copyItem(dataList, null, item);
                let spaceBetween = newItem.blankSpace || 10;
                let top = +(dataList[insertIndex].bottom);
                let addHeight = spaceBetween + (+newItem.height);
                parent.height = +parent.height + addHeight; // 增加父元素高度
                newItem.name += ' 副本';
                item.originName = newItem.name;
                newItem.copy = true;
                dataList.forEach((item) => {
                    this.moveLowerItemByTop(top, addHeight, item);
                })
                dataList.splice(insertIndex + 1, 0, newItem); // 新插入元素放在前面,保持和psd添加图层顺序一致
                this.moveItem(addHeight, item);
            },
            moveItem(height, item){
                item.top = (+item.top) + height;
                item.bottom = item.top + (+item.height);
                item.children && item.children.forEach((item) => {
                    this.moveItem(height, item);
                })
            },
            moveLowerItemByTop(top, height, item){
                if(item.top < top){
                    return;
                }
                if(!item.fixed){
                    item.top = (+item.top) + height;
                    item.bottom = item.top + (+item.height);
                }
                item.children && item.children.forEach((item) => {
                    this.moveLowerItemByTop(top, height, item);
                })
            }
        }
    }
</script>
<style lang="scss">
  @import "./module-panel.scss";
</style>